/**
 * Whether the post-auth destination points back into a submission
 * (a signer resuming a package) — analytics segmentation for the
 * email-code sign-in flow, not a navigation decision.
 */
export function redirectedFromHasSubmissionId(
  redirectedFrom: string | null
): boolean {
  if (!redirectedFrom) return false;
  try {
    const q = new URL(redirectedFrom, 'http://local').searchParams;
    return q.has('submissionId');
  } catch {
    return false;
  }
}
